"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieDomain = getCookieDomain;
exports.__getCookie = __getCookie;
exports.setCookie = setCookie;
exports.enableGoogleTagManager = enableGoogleTagManager;
exports.enableGoogleAnalytics = enableGoogleAnalytics;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/** Function uses passed in parameter value if specified.
   Otherwise, it will use the top level domain (if it can be retrieved).
   As a final option, it will use the browser default value (empty string).

   NOTE: the browser default is not inheritable by subdomains.
 */
function getCookieDomain(cookieDomain) {
  var _document, _document$location;

  // Use input value if specified
  if (cookieDomain) return cookieDomain; // Use top level domain (ar.snap.com => snap.com)

  if (!((_document = document) === null || _document === void 0 ? void 0 : (_document$location = _document.location) === null || _document$location === void 0 ? void 0 : _document$location.hostname)) {
    return "";
  }

  var hostname = document.location.hostname.toLowerCase();
  var parts = hostname.split(".");

  if (parts.length < 2) {
    return hostname;
  }

  return parts[parts.length - 2] + "." + parts[parts.length - 1];
}

function __getCookie(name) {
  return _jsCookie["default"].get(name);
}

function setCookie(name, value) {
  var domain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  _jsCookie["default"].set(name, value, {
    expires: 365,
    secure: true,
    domain: domain
  });
}

function enableGoogleTagManager(GTMID, GAID, gtmCustomCallback) {
  if (window) {
    window["ga-disable-".concat(GAID)] = false
    /*
      You need to insert ; if you start a line with a parantesis ( or a bracket [
      https://stackoverflow.com/a/16421633
    */
    ;

    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', GTMID);

    if (gtmCustomCallback) {
      gtmCustomCallback();
    }
  }
}

function enableGoogleAnalytics(GAID, gaPlugins, gaCustomCallback) {
  if (window) {
    window["ga-disable-".concat(GAID)] = false;
    /*
      You need to insert ; if you start a line with a parantesis ( or a bracket [
      https://stackoverflow.com/a/16421633
    */

    if (GAID.includes('UA-')) {
      ;

      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

      ga('create', GAID, 'auto');
      gaPlugins.forEach(function (plugin) {
        ga('require', plugin.name, plugin.options);
      });
      ga('set', 'anonymizeIp', true);
      ga('send', 'pageview');

      if (gaCustomCallback) {
        gaCustomCallback();
      }
    } else {
      var _window$dataLayer;

      var gtag = function gtag() {
        dataLayer.push(arguments);
      };

      window.dataLayer = (_window$dataLayer = window.dataLayer) !== null && _window$dataLayer !== void 0 ? _window$dataLayer : [];
      var GA4Script = document.createElement('script');
      GA4Script.async = true;
      GA4Script.src = "https://www.googletagmanager.com/gtag/js?id=".concat(GAID);

      GA4Script.onload = function () {
        gtag('js', new Date());
        gtag('config', GAID);
      };

      document.head.appendChild(GA4Script);
    }
  }
}